import { useCallback } from 'react';

import { useAnalyticsUtilities } from '../hooks/useAnalyticsUtilities';
import META from './useTrackShowcaseHeaderLinkAdded.meta';

export const useTrackShowcaseHeaderLinkAdded = () => {
  const { track } = useAnalyticsUtilities();

  const trackShowcaseHeaderLinkAdded = useCallback(() => {
    track(META.name);
  }, [track]);

  return { trackShowcaseHeaderLinkAdded };
};
